export class QuantityInLocations {

  constructor(
    public locationId: number,
    public quantity: number,
  ) {
  }

  static createFromAny(object: any): QuantityInLocations {
    if (object === null || object === undefined) {
      return null;
    }

    return new QuantityInLocations(
      object.locationId,
      object.quantity,
    );
  }
}
